import { TextField } from "@mui/material";

const StringEntry = ({ elementName, fieldLabel, startingValue, setResourceState, marginTop, required }) => {
    return <TextField error={required && !startingValue}
        style={{ width: "100%", marginTop: marginTop || "12px" }} multiline
        className="inputField" type='text' label={fieldLabel} size="small" variant='outlined'
        value={startingValue || ""}
        onChange={(e) => {
            setResourceState(prevState => { return { ...prevState, [elementName]: e.target.value } });
        }} />
};

export default StringEntry;